export const USER_ROLES = {
    manager: 'manager',
    seller: 'seller',
}

export const STATES = {
    created: 'CREATED',
    identified: 'IDENTIFIED',
    confirmed: 'CONFIRMED',
    accepted: 'ACCEPTED',
    agreed: 'AGREED',
    signed: 'SIGNED',
    finished: 'FINISHED',
    identificationBlocked: 'IDENTIFICATION_BLOCKED',
    denialByStopFactor: 'DENIAL_BY_STOP_FACTOR',
    denialByShop: 'DENIAL_BY_SHOP',
    denialByCustomer: 'DENIAL_BY_CUSTOMER',
    denialByScoring: 'DENIAL_BY_SCORING',
    denialByDistribution: 'DENIAL_BY_DISTRIBUTION',
    finalizationBlocked: 'FINALIZATION_BLOCKED',
    requestFailed: 'REQUEST_FAILED',
    faceMatchFailed: 'FACEMATCH_FAILED',
    faceMatchBlocked: 'FACEMATCH_BLOCKED',
    timeout: 'TIMEOUT',
};

export const GROUP_STATES = [
    'DENIAL_BY_SCORING',
    'DENIAL_BY_DISTRIBUTION',
    'IDENTIFICATION_BLOCKED',
    'DENIAL_BY_STOP_FACTOR',
]

export const GROUP_FACEMATCH_STATES = [
    'FACEMATCH_FAILED',
    'FACEMATCH_BLOCKED',
]

export const STATUS_BY_STATE = {
    'CREATED': 'IN_PROGRESS',
    'IDENTIFIED': 'IN_PROGRESS',
    'CONFIRMED': 'IN_PROGRESS',
    'ACCEPTED': 'IN_PROGRESS',
    'AGREED': 'IN_PROGRESS',
    'SIGNED': 'IN_PROGRESS',
    'FINISHED': 'SUCCESS',
    'IDENTIFICATION_BLOCKED': 'CANCEL',
    'DENIAL_BY_STOP_FACTOR': 'CANCEL',
    'DENIAL_BY_SHOP': 'CANCEL',
    'DENIAL_BY_CUSTOMER': 'CANCEL',
    'DENIAL_BY_SCORING': 'CANCEL',
    'DENIAL_BY_DISTRIBUTION': 'CANCEL',
    'FINALIZATION_BLOCKED': 'CANCEL',
    'REQUEST_FAILED': 'CANCEL',
    'TIMEOUT': 'CANCEL',
    'FACEMATCH_FAILED': 'CANCEL',
    'FACEMATCH_BLOCKED': 'CANCEL',
}

export const CATEGORIES = {
    'MOBILE_COMPUTER_TABLET': 'Բջջային հեռախոս, համակարգիչ, տաբլետ',
    'AUTO_PARTS': 'Ավտոմասեր',
    'HOUSEHOLD': 'Կենցաղային տեխնիկա',
    'FURNITURE': 'Կահույք',
    'CONSTRUCTION_MATERIALS_ACCESSORIES_TOOLS': 'Շինարարական նյութեր և պարագաներ',
    'SOLAR': 'Արևային պանելներ',
    'SERVICES': 'Ծառայություններ',
}

export const DOCUMENT_TYPES = {
    GENERAL_SHEET: 'GENERAL_SHEET',
    NOTICE_SHEET: 'NOTICE_SHEET',
    INFO_GATHERING_AGREEMENT_SHEET: 'INFO_GATHERING_AGREEMENT_SHEET',
    RECEIPT_SHEET: 'RECEIPT_SHEET',
    LOAN_DEPOSIT_AGREEMENT_SHEET: 'LOAN_DEPOSIT_AGREEMENT_SHEET',
    COMPLAINT_SHEET: 'COMPLAINT_SHEET',
    COMPLETE_SHEET: 'COMPLETE_SHEET',
    ATTACHMENT: 'ATTACHMENT'
}

export const DENIAL_REASONS = {
    SUSPICIOUS_CUSTOMER: 'SUSPICIOUS_CUSTOMER',
    NON_COMPETITIVE_OFFER: 'NON_COMPETITIVE_OFFER',
    OTHER: 'OTHER',
    INSUFFICIENT_CONDITIONS: 'INSUFFICIENT_CONDITIONS',
    CHANGE_INTENTION: 'CHANGE_INTENTION',
    UNFAVORABLE_CREDIT_CONDITIONS: 'UNFAVORABLE_CREDIT_CONDITIONS'
}